const SupportedLocales = {
  EN: "en",
  ES: "es",
  EN_CA: "en-CA",
};

export default SupportedLocales;
